
import { apiHelper } from "../apiHelper/apiHelper";
import {
  getProductsListRequest,
  getProductsListFailure,
  getProductsListSuccess,
} from "../slices/productsListsSlices";

// ========================== NEW API HANDLER =================

// get Farmers list
export const handleGetProductsList = async (dispatch) => {
  const endPoint = "product/products";
  const method = "GET";
  const state1 = getProductsListRequest;
  const state2 = getProductsListSuccess;
  const state3 = getProductsListFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};
